module.exports = __webpack_public_path__ + "media/images/landkit/covers/cover-15-b399adcd7ba70800a0be0340fc16a5e5.jpg";